var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 40,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.9398 24.9447L15.8666 3H25.1333L23.0601 24.9447H17.9398Z",
  stroke: "#06262D",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5088 36.2032C21.7797 37.9323 18.9762 37.9323 17.2471 36.2032C15.5179 34.474 15.5179 31.6705 17.2471 29.9414C18.9762 28.2122 21.7797 28.2122 23.5088 29.9414C25.238 31.6705 25.238 34.474 23.5088 36.2032Z",
  fill: "#FFAD0D"
})));
export { SvgExclamation as ReactComponent };
export default __webpack_public_path__ + "images/exclamation.svg";